import { cloneDeep } from "lodash-es";
import { ResultRow } from "../../../data-structures/results/result-row.model";

/**
 * Digestre Output Flows
 */
interface DOFInterface {
 'RESULTS.DATA.TECHNICAL.DFR'?: ResultRow;
 'RESULTS.DATA.TECHNICAL.BP'?: ResultRow;
 'RESULTS.DATA.TECHNICAL.MPFOB'?: ResultRow;
 'RESULTS.DATA.TECHNICAL.CDPFOB'?: ResultRow;
}
export class DOF {
  'RESULTS.DATA.TECHNICAL.DFR';
  'RESULTS.DATA.TECHNICAL.BP';
  'RESULTS.DATA.TECHNICAL.MPFOB';
  'RESULTS.DATA.TECHNICAL.CDPFOB';

  /** Digestate Flow Rate */
  get dfr() {
    return this['RESULTS.DATA.TECHNICAL.DFR'];
  }
  set dfr(value: ResultRow) {
    this['RESULTS.DATA.TECHNICAL.DFR'] = value;
  }
  /** Biogas Production */
  get bp() {
    return this['RESULTS.DATA.TECHNICAL.BP'];
  }
  set bp(value: ResultRow) {
    this['RESULTS.DATA.TECHNICAL.BP'] = value;
  }
  /** methane production (fraction of biogas) */
  get mpfob() {
    return this['RESULTS.DATA.TECHNICAL.MPFOB'];
  }
  set mpfob(value: ResultRow) {
    this['RESULTS.DATA.TECHNICAL.MPFOB'] = value;
  }
  /** carbon dioxide production (fraction of biogas) */
  get cdpfob() {
    return this['RESULTS.DATA.TECHNICAL.CDPFOB'];
  }
  set cdpfob(value: ResultRow) {
    this['RESULTS.DATA.TECHNICAL.CDPFOB'] = value;
  }

  constructor(params: DOFInterface = {}) {
    this['RESULTS.DATA.TECHNICAL.DFR'] = params['RESULTS.DATA.TECHNICAL.DFR']
      ? new ResultRow(params['RESULTS.DATA.TECHNICAL.DFR'])
      : new ResultRow();

    this['RESULTS.DATA.TECHNICAL.BP'] = params['RESULTS.DATA.TECHNICAL.BP']
      ? new ResultRow(params['RESULTS.DATA.TECHNICAL.BP'])
      : new ResultRow();

    this['RESULTS.DATA.TECHNICAL.MPFOB'] = params['RESULTS.DATA.TECHNICAL.MPFOB']
      ? new ResultRow(params['RESULTS.DATA.TECHNICAL.MPFOB'])
      : new ResultRow();

    this['RESULTS.DATA.TECHNICAL.CDPFOB'] = params['RESULTS.DATA.TECHNICAL.CDPFOB']
      ? new ResultRow(params['RESULTS.DATA.TECHNICAL.CDPFOB'])
      : new ResultRow();
  }

  deepCopy() {
    return new DOF(cloneDeep(this));
  }
}
